<template>
  <v-card flat id="filtres-portails">
    <v-card-text>
      <v-row>
        <v-col cols="12" md="2">
          <v-text-field
            label="ID Passman"
            v-model="passmanIdFilter"
            @keydown="() => clearTypingTimer(typingTimerIdPassmanId)"
            @keyup="triggerTypingTimerPassmanId"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="2">
          <v-text-field
            label="ID Externe"
            v-model="externalIdFilter"
            @keydown="() => clearTypingTimer(typingTimerIdExternalId)"
            @keyup="triggerTypingTimerExternalId"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="2">
          <v-text-field
            label="Description"
            v-model="descriptionFilter"
            @keydown="() => clearTypingTimer(typingTimerIdDescription)"
            @keyup="triggerTypingTimerDescription"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="2">
          <v-select
            label="Versions"
            deletable-chips
            chips
            multiple
            hide-details
            :items="versions"
            clearable
            small-chips
            v-model="criteria.versions"
          ></v-select>
        </v-col>
        <v-col cols="12" md="2">
          <v-select
            label="Etat"
            :items="actives"
            v-model="criteria.isActive"
            clearable
            small-chips
            deletable-chips
            chips
            multiple
            hide-details
          ></v-select>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import { defineComponent, ref } from "@vue/composition-api";

export default defineComponent({
  props: {
    criteria: Object,
  },
  setup(props, { emit }) {
    /* Variables */
    const versions = [
      { text: "V2", value: 0 },
      { text: "V3", value: 1 },
      { text: "V4", value: 2 },
      { text: "V5", value: 3 },
    ];
    const actives = [
      { text: "Actif", value: true },
      { text: "Inactif", value: false },
    ];
    let typingTimerIdPassmanId = 0;
    let typingTimerIdExternalId = 0;
    let typingTimerIdDescription = 0;
    const debounceInterval = 500;
    const passmanIdFilter = ref(props.criteria.passmanId);
    const externalIdFilter = ref(props.criteria.reference);
    const descriptionFilter = ref(props.criteria.description);

    /* Méthodes */
    const triggerTypingTimerPassmanId = function () {
      clearTimeout(typingTimerIdPassmanId);
      typingTimerIdPassmanId = setTimeout(function () {
        const terms = passmanIdFilter.value;
        const proxy = { ...props.criteria };
        proxy.passmanId = terms;
        emit("update:criteria", proxy);
      }, debounceInterval);
    };
    const triggerTypingTimerExternalId = function () {
      clearTimeout(typingTimerIdExternalId);
      typingTimerIdExternalId = setTimeout(function () {
        const terms = externalIdFilter.value;
        const proxy = { ...props.criteria };
        proxy.reference = terms;
        emit("update:criteria", proxy);
      }, debounceInterval);
    };
    const triggerTypingTimerDescription = function () {
      clearTimeout(typingTimerIdDescription);
      typingTimerIdDescription = setTimeout(function () {
        const terms = descriptionFilter.value;
        const proxy = { ...props.criteria };
        proxy.description = terms;
        emit("update:criteria", proxy);
      }, debounceInterval);
    };
    const clearTypingTimer = function (timerId) {
      clearTimeout(timerId);
    };

    return {
      versions,
      actives,
      triggerTypingTimerPassmanId,
      typingTimerIdPassmanId,
      triggerTypingTimerExternalId,
      typingTimerIdExternalId,
      triggerTypingTimerDescription,
      typingTimerIdDescription,
      clearTypingTimer,
      passmanIdFilter,
      externalIdFilter,
      descriptionFilter,
    };
  },
});
</script>
